import { QUES_COMPONENT_TYPES } from '../componentTypes';
import EXTRA_COMPONENT_TYPE from '@modules/questionnaires/extraComponent/extraComponentType';

export default [
  {
    sequenceNumber: 8,
    subTitle: 'TODO subTitle',
    content: 'Can you confirm the number of employees at the Buyer and Target?',
    subSection: 'TODO subSection',
    type: QUES_COMPONENT_TYPES.RADIO,
    bodyExtraComponentType: EXTRA_COMPONENT_TYPE.HeadcountTable,
    options: [
      { text: 'Buyer has significantly more employees than Target' },
      { text: 'Buyer & Target have relatively similar number of employees' },
      { text: 'Buyer has significantly less employees than Target' },
    ],
    compLocation: 'up',
  },
  {
    sequenceNumber: 9,
    subTitle: 'TODO subTitle',
    content: 'How similar are the Buyer and Target company cultures?',
    subSection: 'TODO subSection',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: [
        'Very Similar',
        'Similar',
        'Somewhat Similar',
        'Dissimilar',
        'Very Dissimilar',
      ],
      compLocation: 'up',
    },
  },
  {
    sequenceNumber: 10,
    subTitle: 'TODO subTitle',
    content: 'How complex is the operational footprint?',
    subSection: 'TODO subSection',
    titleExtraComponentType: EXTRA_COMPONENT_TYPE.LinkToLESubsidiaries, // prevent circular reference
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      {
        text: 'No cross-border activity (all business operations are conducted in 1 Legal Entity)',
      },
      {
        text: 'Minimal cross-border activity (business operations are conducted in 2-5 Legal Entities)',
      },
      {
        text: 'Cross-Border / International (business operations are conducted in more than 5 Legal Entities)',
      },
    ],
    compLocation: 'up',
  },
];
